export const BANNER_HEIGHTS = {
	mobile: 336,
	mobileShort: 220,
	desktop: 452
};

export const IMG_SIZES = {
	foreground: '(max-width: 1028px) 300px, (max-width: 1750px) 640px, 33vw',
	background: '(max-width: 375px) 420px, (max-width: 768px) 860px, (max-width: 1028px) 1080px, 100vw'
};
